import { render } from "./LazyPicture.vue?vue&type=template&id=153ae1c8&ts=true"
import script from "./LazyPicture.vue?vue&type=script&lang=ts"
export * from "./LazyPicture.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__